export default __webpack_public_path__ + "static/media/photo-13.dba65aac.jpeg";